import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  useStyleConfig
} from "@chakra-ui/react";

const TemplateEditorModal = ({
                              isOpen,
                              onBack,
                              onSave,
                              onClose,
                            }) => {
  const saveButtonStyle = useStyleConfig(
    'Button',
    { variant: 'saveButton' }
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Edit Template
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody className="template-editor-modal">
          <div id="bee-plugin-container" className="bee-plugin-container" />
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="green"
            variant="ghost"
            onClick={onBack}
            isDisabled={false}
          >
            Back
          </Button>
          <Button
            __css={saveButtonStyle}
            colorScheme="blue"
            mr={3}
            onClick={onSave}
            isDisabled={false}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TemplateEditorModal;
